<template>
  <div id="app">
    <router-view />
    <!-- <baidu-map class="bm-view">
    </baidu-map> -->
    <!--<chart></chart>-->
  </div>
</template>

<script>
// import BaiduMap from './components/map/maps'

export default {
  name: 'App',
  // components: {
  //   BaiduMap,
  // }
  data() {
    return {};
  },
  mounted() {},
};
</script>

<style>
body,
html {
  width: 100%;
  height: 100%;
  margin: 0;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
  width: 100%;
}
</style>
